import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';
import WhyChooseUs from './components/WhyChooseUs';
import FeaturedSpecialties from './components/FeaturedSpecialties';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const HomePage = () => (
  <div className="min-h-screen bg-[#0A1628] font-sans">
    <Navbar />
    <main>
      <Hero />
      <ServicesOverview />
      <WhyChooseUs />
      <FeaturedSpecialties />
      <Testimonials />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default HomePage;
